<div class="dropdown-menu-media dropdown-menu-right d-block notification-card">
  <!-- Notifications header -->
  <div class="dropdown-menu-header">
    <div class="dropdown-header d-flex justify-content-between h3-bold p-3">
      <h4 class="notification-title mb-0 mr-auto h3-bold">Download List</h4>
      <app-icon-btn
        [active]="false"
        size="medium"
        iconType="change"
        position="right"
        [disabled]="buttonDisabled()"
        (click)="refreshDownloads()"
        [matTooltip]="tooltipData()"
        [matTooltipPosition]="'above'"></app-icon-btn>
    </div>
  </div>

  <div
    class="messages d-flex align-items-center justify-content-start flex-column custom-scroll"
    (scroll)="onScroll($event)">
    <!-- Use global loader wrapper only when no persistent data exists -->
    @if (!persistentDownloadsData()) {
      <app-global-loader-wrapper [resource]="downloadsResource">
        <ng-template></ng-template>
      </app-global-loader-wrapper>
    }

    <!-- Show content when we have persistent data -->
    @if (persistentDownloadsData()) {
      @for (download of persistentDownloadsData()?.list || []; track download.job_id) {
        <div
          class="download-item w-100"
          [class.border-bottom]="(persistentDownloadsData()?.list || []).length > 1">
          <h4
            class="m-0 h4-bold primary-100 d-flex align-items-center justify-content-between w-100">
            <div class="d-flex flex-column spacing-4">
              <app-badges [Type]="'white'" [label]="download.data_source"></app-badges>
              <span>{{ download.name }}</span>
              <div class="date h4-reg primary-100">
                {{ getTimeInterval(download.created_at) }}
              </div>
            </div>
            <div class="d-flex align-items-center spacing-12">
              <app-badges
                [Type]="getStatusBadge(download.status)"
                [label]="download.status"></app-badges>
              @if (download.download) {
                <app-action-btn
                  class="cursor-pointer"
                  [active]="false"
                  [disabled]="!download.download"
                  IconType="download"
                  [matTooltip]="'Download'"
                  [matTooltipPosition]="'above'"
                  (custom_click)="onDownload(download.job_id)"></app-action-btn>
              }
            </div>
          </h4>
        </div>
      }

      <!-- Show pagination loading spinner when loading more -->
      @if (isLoadingMore()) {
        <div class="loading-spinner d-flex align-items-center justify-content-center p-3 w-100">
          <app-ce-icon
            [name]="'loader'"
            [svg_class]="['d-flex', 'primary-50']"
            class="loader-spin"></app-ce-icon>
        </div>
      }
    }
  </div>
</div>
